module.exports = __webpack_public_path__ + "static/media/unionpay.9b59a572.svg";